import { Chip as ChipMui, ChipProps as ChipPropsMui } from '@mui/material';

export type ChipProps = Pick<
  ChipPropsMui,
  | 'avatar'
  | 'children'
  | 'clickable'
  | 'color'
  | 'deleteIcon'
  | 'disabled'
  | 'icon'
  | 'label'
  | 'onDelete'
  | 'sx'
  | 'size'
  | 'variant'
  | 'component'
>;

export function Chip({ ...rest }: ChipProps) {
  return <ChipMui {...rest} />;
}
